import printRoutesComponent from './print_routes.component';

let printRoutesModule = angular.module('printRoutes', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/routes');

		$stateProvider
			.state('printRoutes', {
				url: '/print-routes',
				component: 'printRoutes',
				data: {
					requireLogin: true,
					requireACL: 'branch_mgmt_routes.all'	
				},
			});
	})

	.component('printRoutes', printRoutesComponent)

	.name;

export default printRoutesModule;

// ?branch&route&date



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/print/index.js